module.exports = __webpack_public_path__ + "img/26_109.1fd2db60.png";